export const INNSYN_BASE_PATH = '/app'

export const INNSYN_SEARCH_PATH = INNSYN_BASE_PATH + '/search'

export const INNSYN_SAVED_PATH = INNSYN_BASE_PATH + '/saved'

export const INNSYN_SEARCH_OEREMERKE_PATH = INNSYN_SEARCH_PATH + '/tag'

export const INNSYN_SEARCH_OEREMERKE_BASE_SNITT_PATH =
    INNSYN_SEARCH_OEREMERKE_PATH + '/select-cut'

export const INNSYN_SEARCH_OEREMERKE_SNITT_COMBINATION_PATH =
    INNSYN_SEARCH_OEREMERKE_PATH + '/select-cut-combination'

export const INNSYN_SEARCH_OEREMERKE_OMRAADE_PATH =
    INNSYN_SEARCH_OEREMERKE_PATH + '/select-area'

export const INNSYN_SEARCH_OEREMERKE_DISTRIKT_ABSTRACT_PATH =
    INNSYN_SEARCH_OEREMERKE_PATH + '/select-district/:areaId'
export const INNSYN_SEARCH_OEREMERKE_DISTRIKT_PATH = (areaId: number) =>
    INNSYN_SEARCH_OEREMERKE_PATH + `/select-district/${areaId}`

export const INNSYN_SEARCH_NAME_PATH = INNSYN_SEARCH_PATH + '/name'

export const INNSYN_SEARCH_RESULTS_PATH = INNSYN_SEARCH_PATH + '/results'

export const INNSYN_SEARCH_NAME_RESULTS_PATH =
    INNSYN_SEARCH_PATH + '/namesearch'

export const INNSYN_SEARCH_OEREMERKE_INFO_ABSTRACT_PATH =
    INNSYN_SEARCH_RESULTS_PATH + '/tag-info/:id'

export const INNSYN_SEARCH_OEREMERKE_INFO_PATH = (id: number) =>
    INNSYN_SEARCH_RESULTS_PATH + `/tag-info/${id}`
